var _path, _path2, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 45,
    viewBox: "0 0 32 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1248 37.0191C15.9152 37.0191 30.0377 22.5586 30.0377 14.6657C30.0377 6.77267 23.3609 0.374146 15.1248 0.374146C6.88863 0.374146 0.211914 6.77267 0.211914 14.6657C0.211914 22.5586 14.3344 37.0191 15.1248 37.0191ZM15.1248 21.8138C19.3006 21.8138 22.6857 18.5697 22.6857 14.5679C22.6857 10.5662 19.3006 7.32212 15.1248 7.32212C10.9491 7.32212 7.56399 10.5662 7.56399 14.5679C7.56399 18.5697 10.9491 21.8138 15.1248 21.8138Z",
    fill: "#F93232"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.211914 14.6657C0.211914 22.5586 14.3344 37.0191 15.1248 37.0191V21.8138C10.9491 21.8136 7.56399 18.5697 7.56399 14.5679C7.56399 10.5662 10.9491 7.32214 15.1248 7.32212V0.374146C6.88863 0.374146 0.211914 6.77267 0.211914 14.6657Z",
    fill: "#FF5757"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.1113,
    cy: 40.8334,
    rx: 8,
    ry: 4.16667,
    fill: "#F93232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/mapPin.64488929dafbaedef06a07de8b27aac7.svg";
export { ForwardRef as ReactComponent };